<template>
  <div>
    <div class="recruit">
      <h2>加入追梦者团队，让人生更具精彩与价值！</h2>
      <div class="card" v-for="(item, index) in list" :key="index">
        <div class="content" @click="goDetail(index)">
          <img :src="item.img">
          <div class="text-right">
            <h3>{{item.title}}</h3>
            <span class="more">了解详情</span>
            <h4>职位描述：</h4>
            <div v-for="(message, index) in item.children" :key="index">
              <span v-for="(name, index) in message" :key="index">{{name}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>
<script>
import Footer from "@/components/Footer";
export default {
  name: "Recruit",
  data() {
    return {
      list: [],
      store: this.$store.state
    };
  },
  components: {
    Footer
  },
  methods: {
    goDetail(index) {
      this.$router.push(`/recruit-detail/${index}`);
    }
  },
  mounted() {
    this.list = this.store.recruit
  },
};
</script>
<style lang="less" scoped>
@media (min-width: 997px) {
  .recruit {
    margin-top: 80px;
    padding: 40px 80px 110px 80px;
    h2 {
      font-size: 30px;
      margin-bottom: 10px;
    }
    .card {
      img {
        display: block;
        float: left;
        width: 300px;
        padding: 20px;
        margin-right: 20px;
      }
      .text-right {
        float: left;
        width: calc(100% - 320px);
        h3 {
          font-size: 24px;
        }
        .more {
          font-size: 12px;
        }
      }
    }
  }
}
@media (max-width: 997px) {
  .recruit {
    margin-top: 60px;
    padding: 0px 30px 40px 30px;
    h2 {
      text-align: center;
      font-size: 14px;
    }
    .card {
      img {
        width: 100%;
        margin-bottom: 10px;
      }
      .text-right {
        h3 {
          font-size: 14px;
        }
        .more {
          font-size: 10px;
        }
        span {
          font-size: 10px;
        }
      }
    }
  }
}
.recruit {
  h2 {
    height: 70px;
    line-height: 70px;
    color: #5f5d5d;
    margin: 0;
  }
  h2, h3 {
    font-weight: normal;
  }
  .card + .card {
    margin-top: 20px;
  }
  .card {
    border: 1px solid #ccc;
    background: #f8f8f8;
    text-align: left;
    cursor: pointer;
    .content {
      padding: 20px;
      overflow: hidden;
      zoom: 1;
    }
    .text-right {
      h3 {
        color: #727071;
        margin: 0;
      }
      h4 {
        color: #000;
        font-size: 16px;
        margin: 20px 0 10px;
        font-weight: bold;
      }
      div {
        color: #666;
      }
      span {
        margin-right: 15px;
        display: inline-block;
      }
      .more {
        color: #666;
        float: right;
        margin-top: -20px;
      }
    }
  }
}
</style>
